export interface BibeHostnameInfo {
  bibePrefix: string
  effectiveHostname: string
  bibeType?: 'staging-bibes' | 'prod-bibes'
  bibeNumber?: string
  envModifier: string
  productSubdomain?: string
}

export function parseBibeHostname(
  hostname: string = window.location.hostname,
): BibeHostnameInfo {
  hostname = hostname.toLowerCase()
  // Step 1: Extract BIBE prefix if presen
  const bibePrefixRegex = /^(\d+)\.(staging-bibes|prod-bibes)\.(.+)$/
  const bibeMatch = hostname.match(bibePrefixRegex)
  if (bibeMatch) {
    const [, bibeNumber, bibeType, rest] = bibeMatch
    return {
      bibePrefix: `${bibeNumber}.${bibeType}.`,
      bibeType: bibeType === 'staging-bibes' ? 'staging-bibes' : 'prod-bibes',
      bibeNumber,
      ...parseEnvModifierAndSubdomain(rest),
    }
  }

  // Step 2: Handle non-BIBE hostnames
  return {
    bibePrefix: '',
    ...parseEnvModifierAndSubdomain(hostname),
  }
}

function parseEnvModifierAndSubdomain(
  host: string,
): Pick<
  BibeHostnameInfo,
  'effectiveHostname' | 'envModifier' | 'productSubdomain'
> {
  const genericRegex = /^(.+?)\.(dev|local|staging)\.buffer\.com/
  const [, subdomain, envModifier = ''] = host.match(genericRegex) ?? []

  const envPrefix = envModifier ? `${envModifier}.` : ''
  const effectiveHostname = subdomain
    ? `${subdomain}.${envPrefix}buffer.com`
    : host

  const productSubdomain = effectiveHostname.includes('.')
    ? effectiveHostname.split('.')[0]
    : undefined

  return {
    effectiveHostname,
    productSubdomain,
    envModifier: envPrefix,
  }
}
